import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Star from '@material-ui/icons/Star';
import Gravatar from 'ui/Gravatar';

const styles = () => ({
    root: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        paddingLeft: '7px',
        maxWidth: '80%',
    },
    name: {
        display: 'flex',
        alignItems: 'flex-end',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontWeight: '500',
    },
    email: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    primaryUserStar: {
        color: '#ee901a',
        fontSize: '1.2125rem',
    },
    tooltip: {
        fontSize: '0.75rem',
    },
});

const UserInfo = ({ user, classes }) => (
    <div className={classes.root}>
        <Gravatar email={user.email} color={user.color} />
        <div className={classes.wrapper}>
            <span className={classes.name}>
                {user.first_name} {user.last_name}{' '}
                {user.is_primary_account && (
                    <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        title="Primary user account"
                    >
                        <Star className={classes.primaryUserStar} />
                    </Tooltip>
                )}
            </span>
            <span className={classes.email}>{user.email}</span>
        </div>
    </div>
);

export default withStyles(styles)(UserInfo);
